import { render, staticRenderFns } from "./StartupPress.vue?vue&type=template&id=3140871f&"
import script from "./StartupPress.vue?vue&type=script&lang=js&"
export * from "./StartupPress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports